/* eslint-disable */
import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const DonutTile = ({ title, dataValue = 0, remainingValue = 100 }) => {
  const total = dataValue + remainingValue;
  const percentage = total ? ((dataValue / total) * 100).toFixed(1) : 0;

  const data = {
    labels: ["Completed", "Remaining"],
    datasets: [
      {
        data: [Number(dataValue).toFixed(2), Number(remainingValue).toFixed(2)],
        backgroundColor: ["#28a745", "#e9ecef"],
        borderWidth: 0,
        cutout: "70%",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 12,
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw}`;
          },
        },
      },
    },
  };

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0px 4px 12px rgba(0,0,0,0.20)",
        textAlign: "center",
        height: "260px",
      }}
    >
      {/* Title */}
      <h6 style={{ fontWeight: "600", marginBottom: "15px" }}>
        {title}
      </h6>

      {/* Chart */}
      <div style={{ position: "relative", height: "200px" }}>
        <Doughnut data={data} options={options} />

        {/* Center Text */}
        <div
          style={{
            position: "absolute",
            top: "35%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          {percentage}%
        </div>
      </div>
    </div>
  );
};

export default DonutTile;